export const STIPEND_GRAND_TOTAL_CONTAINER = 'stipend--grand-total-container';
export const STIPEND_LEGEND_ICON = 'stipend--legend-icon';
